/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_norm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is normality related to molarity?`)
};

const es_norm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se relaciona la normalidad con la molaridad?`)
};

const de_norm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie hängt Normalität mit Molarität zusammen?`)
};

const nl_norm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe hangt normaliteit samen met molariteit?`)
};

const fr_norm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment la normalité est-elle liée à la molarité ?`)
};

const it_norm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come si relaziona la normalità alla molarità?`)
};

const pt_br2_norm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como a normalidade se relaciona com a molaridade?`)
};

const pt_norm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como se relaciona a normalidade com a molaridade?`)
};

const ja_norm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`規定度とモル濃度の関係は？`)
};

const zh_norm_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`当量浓度与摩尔浓度有什么关系？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const norm_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.norm_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("norm_faq_q4", locale)
	if (locale === "en") return en_norm_faq_q4(inputs)
	if (locale === "es") return es_norm_faq_q4(inputs)
	if (locale === "de") return de_norm_faq_q4(inputs)
	if (locale === "nl") return nl_norm_faq_q4(inputs)
	if (locale === "fr") return fr_norm_faq_q4(inputs)
	if (locale === "it") return it_norm_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_norm_faq_q4(inputs)
	if (locale === "pt") return pt_norm_faq_q4(inputs)
	if (locale === "ja") return ja_norm_faq_q4(inputs)
	return zh_norm_faq_q4(inputs)
};